module.exports = __webpack_public_path__ + "img/category-popular-hover.9a216574.png";